<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberEntry/edit?id=' + $route.query.member_id)" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-6 text-right">
            <b-btn @click="openPage('/memberEntry/addNewPtSession?id=' + $route.query.id + '&member_id=' + $route.query.member_id)"
              size="sm" class="btn-table green ml-5">
              <i class="fas fa-plus-square mr-5"></i>New Session 
            </b-btn>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="submitData">
              <b-row class="mb-20">
                <b-col sm="3" md="2">
                  <label>Personal Trainer</label>
                </b-col>
                <b-col sm="9" md="10">
                  <b-form-select class="w-100" name="personal_trainer" v-validate="'required'" v-model="editData.personal_trainer_id">
                    <option :value="null">Please select</option>
                    <option v-for="listItem in itemPt" :key="listItem.id" :value="listItem.id">{{listItem.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('personal_trainer') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Total Session</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input disabled v-model="editData.buy_session_qty" name="buy_session_qty" v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('buy_session_qty') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Current Session</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.current_session_qty" name="current_session_qty" v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('current_session_qty') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3" md="2">
                  <label>Running Session</label>
                </b-col>
                <b-col sm="9" md="10">
                  <flat-pickr :config="config" v-model="editData.created_at" name="date" class="w-100"></flat-pickr>
                  <span class="error">{{ errors.first('date') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3" md="2">
                  <label>Expired Date</label>
                </b-col>
                <b-col sm="9" md="10" v-if="paradigm_role_id != 1">
                  <flat-pickr :disabled="disabledEpiredDate" :config="editData.update_exp_2 != null ? config2 : config3" v-model="editData.expired_at" name="expired_at" class="w-100"></flat-pickr>
                  <span class="error">{{ errors.first('expired_at') }}</span>
                  <span class="error" v-if="editData.update_exp_1 != null && editData.update_exp_2 == null">Warning can only change 1 more time</span>
                  <span class="error" v-if="editData.update_exp_2 != null">Can't change Expired Date</span>
                  <span class="error" v-if="disabledEpiredDate">Can't change Expired Date</span>
                </b-col>
                <b-col sm="9" md="10" v-else>
                  <flat-pickr :config="config3" v-model="editData.expired_at" name="expired_at" class="w-100"></flat-pickr>

                </b-col>

              </b-row>
              <b-row class="mb-20">
                <b-col sm="3" md="2">
                  <label>Status</label>
                </b-col>
                <b-col sm="9" md="10">
                  <b-form-select class="w-100" name="personal_trainer" v-validate="'required'" v-model="editData.is_active">
                    <option value="">Please select</option>
                    <option value="1">Active</option>
                    <option value="0">Waiting</option>
                    <option value="2">Expired</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('personal_trainer') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3" md="2">
                  <label>Notes</label>
                </b-col>
                <b-col sm="9" md="10">
                  <textarea name="notes" v-validate="'required'" v-model="editData.notes" class="w-100" rows="4"></textarea>
                  <span class="error">{{ errors.first('notes') }}</span>
                </b-col>
              </b-row>
              <div class="text-right mb-20">
                <!-- <button :disabled="disabledExpiredDate" type="submit" class="btn-primary">Submit</button> -->
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
            <hr>
            <div class="mb-40 mt-40">
              <div class="title font-300 font-20 mb-15">
                Running Session History
              </div>
              <table class="table border-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>PT Name</th>
                    <th>Transaction Type</th>
                    <th>Gross Amount</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(itemData, index) in itemListEdit" :key="index">
                    <td>{{itemData.id}}</td>
                    <td>{{itemData.personal_training ? itemData.personal_training.name : ''}}</td>
                    <td>{{itemData.transaction_type ? itemData.transaction_type.name : ''}}</td>
                    <td>Rp. {{parseFloat(itemData.gross_amount).toLocaleString('id-ID', {maximumFractionDigits:2})}}</td>
                    <td>{{parseDate(itemData.created_at)}}</td>
                  </tr>
                </tbody>
              </table>
              <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                  :total-pages="totalPage"
                  @page-changed="pageOneChanged"
                  prev-text="Prev" next-text="Next"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'addPtSession',
  components: {
    'app-pagination': Pagination
  },
  data: function () {
    return {
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      itemPt: [],
      itemPtSession: [],
      itemListEdit: [],
      paradigm_role_id: Auth.Session.get().paradigm_role,
      editData: {
        notes: '',
        member_id: '',
        buy_session_qty: '',
        personal_trainer_id: '',
        expired_at: '',
        created_at: '',
        current_session_qty: '',
        is_active: ''
      },
      config: {
        altInput: true,
        altFormat: 'j F Y H:i',
        dateFormat: 'Y-m-d H:i',
        enableTime: true,
        enableSeconds: true,
        time_24hr: true
      },
      config2: {
        altInput: true,
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d',
        enableTime: false
      },
      config3: {
        altInput: false,
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d',
        enableTime: false
      },
      disabledEpiredDate: false,
    }
  },
  methods: {
    disabledBackDate() {
      // disable if month is more than current month
      // this.disabledEpiredDate = true
      const year = moment().format('YYYY')
      const month = moment().format('M')
      
      axios.get('crm/v1/closing_period/member_pt_session?year='+year+'&bulan='+month).then(response => {
        const data = response.data.data
        if (data) {
          this.disabledEpiredDate = true
        }
      }).catch(error => {
        this.disabledEpiredDate = false
        console.log('error', error)
      })
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    parseDate(event) {
      return moment(event).format('DD MMMM YYYY')
    },
    submitData () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          this.editData.paradigm_role_id = this.paradigm_role_id
          axios.put('fitness/v1/member_pt_session/' + this.$route.query.id, this.editData).then(response => {
            // console.log('test', response)
            this.$router.push('/memberEntry/edit?id=' + this.$route.query.member_id)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('fitness/v1/personal_training/').then(response => {
        this.itemPt = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/pt_session?sorting=name&sorting_type=asc').then(response => {
        this.itemPtSession = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/member_pt_session/' + this.$route.query.id).then(response => {
        // console.log(response.data.data)
        this.editData.member_id = response.data.data.member_id
        this.editData.buy_session_qty = response.data.data.buy_session_qty
        this.editData.personal_trainer_id = response.data.data.personal_trainer_id
        this.editData.created_at = response.data.data.created_at
        this.editData.expired_at = response.data.data.expired_at
        this.editData.current_session_qty = response.data.data.current_session_qty
        this.editData.is_active = response.data.data.is_active
        this.editData.update_exp_1 = response.data.data.update_exp_1
        this.editData.update_exp_2 = response.data.data.update_exp_2

        const year = moment(this.editData.expired_at).format('YYYY')
        const month = moment(this.editData.expired_at).format('M')
        
        axios.get('crm/v1/closing_period/member_pt_session?year='+year+'&bulan='+month).then(response => {
          const data = response.data.data
          this.disabledExpiredDate = true
        }).catch(error => {
          // this.disabledExpiredDate = false
          console.log('error', error)
        })

        axios.get('fitness/v1/member_pt_session/running/' + response.data.data.trx_id + '?page=' + this.currentPage + '&limit=' + this.paginationLimit).then(response => {
          this.itemListEdit = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', this.itemListEdit)
        }).catch(error => {
          console.log('error', error)
        })
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
